import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerificaEmail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage(t("verificaEmail.linkInvalid"));
      return;
    }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/verify-email`, { token });
        setStatus("ok");
        setMessage(res.data?.message || t("verificaEmail.successFallbackMessage"));
      } catch (e) {
        setStatus("error");
        setMessage(e?.response?.data?.detail || t("verificaEmail.errorFallbackMessage"));
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-5" style={{ background: "var(--bg)" }}>
      <div className="vs-card p-8 max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <div className="vs-spinner mx-auto mb-4" />
            <p style={{ color: "var(--text-secondary)" }}>{t("verificaEmail.verifyingText")}</p>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h1 className="heading text-xl font-extrabold mb-2" style={{ color: "var(--text-primary)" }}>
              {t("verificaEmail.successTitle")}
            </h1>
            <p className="mb-6" style={{ color: "var(--text-secondary)" }}>{message}</p>
            <button
              onClick={() => navigate("/dashboard")}
              className="vs-btn-primary w-full"
              style={{ background: "var(--primary)", border: "2px solid var(--primary)" }}
            >
              {t("verificaEmail.goToAppButton")}
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <div className="text-5xl mb-4">⚠️</div>
            <h1 className="heading text-xl font-extrabold mb-2" style={{ color: "var(--text-primary)" }}>
              {t("verificaEmail.errorTitle")}
            </h1>
            <p className="mb-6" style={{ color: "var(--text-secondary)" }}>{message}</p>
            <button
              onClick={() => navigate("/")}
              className="vs-btn-primary w-full"
              style={{ background: "var(--primary)", border: "2px solid var(--primary)" }}
            >
              {t("verificaEmail.backToLoginButton")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
